import OperatorService from "@/api/services/operator.service";

const SideTaskTypesService = {
  fetchList() {
    return OperatorService.get("/sidetask-types");
  }
}

export default SideTaskTypesService;
